import React from 'react';
import { OrderItem } from '../../../models/OrderItem';
import { ProductGrouping } from '../../../models/ProductGrouping';
import { FormProductGroupByType } from './FormProductGroupByType';

export class FormProductGroupValues {
  selectedItems: number[];
}

interface IFormProductGroupProps {
  values: FormProductGroupValues;
  orderItems?: OrderItem[];
  productGroups?: ProductGrouping[];
}

const FormProductGroup: React.FC<IFormProductGroupProps> = ({
  values,
  orderItems,
  productGroups
}) => {

  return (
    <>
      <div style={{marginBottom:'15px'}}>
        <FormProductGroupByType
          headerTitle='Armações'
          messageForEmptyList='O pedido não possui armação.'
          productGroups={productGroups}
          orderItems={orderItems?.filter(orderItem => orderItem.active && orderItem.name.toLowerCase().includes('óculos')) || []}
          changeSelectedItem={changeSelectedItem}
        />
      </div>
      <div>
        <FormProductGroupByType
          headerTitle='Lentes'
          messageForEmptyList='O pedido não possui lente.'
          productGroups={productGroups}
          orderItems={orderItems?.filter(orderItem => orderItem.active && orderItem.name.toLowerCase().includes('lente')) || []}
          changeSelectedItem={changeSelectedItem}
        />
      </div>
    </>
  );

  function orderItemIsSelected(orderItemId: number) {
    return values?.selectedItems?.some(id => id === orderItemId);
  }

  function changeSelectedItem(orderItemId: number) {
    if (!values.selectedItems) values.selectedItems = [];
    const itemIsSelected = orderItemIsSelected(orderItemId);
    if (itemIsSelected) {
      values.selectedItems = values.selectedItems.filter(id => id !== orderItemId);
      return;
    }
    values.selectedItems.push(orderItemId);
  }
}

export { FormProductGroup };